import { downloadFlightEvaluationPdf } from '@src/main/modules/reports/flight/application/use-cases/download-flight-evaluation-pdf.usecase';
import { createFlightEvaluationHttpRepository } from '@src/main/modules/reports/flight/infrastructure/repository/FlightEvaluationHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDownloadFlightEvaluationPdf = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFlightEvaluationHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (evaluationId: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await downloadFlightEvaluationPdf(repository, evaluationId);
    },
  });
};
